import React, { useContext, Fragment } from 'react';
/* This is a third-party library that allows us to replace text in a string with HTML. */
import reactStringReplace from 'react-string-replace';
import sanitizeHtml from 'sanitize-html';
import { lobDemoSplit } from '../utils/LobLogicModule'; 
import ErrorGeneric from '../pages/ErrorGeneric';
import queryString from 'query-string';
import BankingTypeContext from './BankingType/context';
import * as SELECTORS from '../constants/selectors';

export const BlobParam = (locParam) => {
	const values = queryString.parse(locParam);
	if(values.cm_mmc && values.cm_sp) {
		return '?cm_mmc='+values.cm_mmc+'&cm_sp='+values.cm_sp;
	} else if(values.cm_mmc && !values.cm_sp) {
		return '?cm_mmc='+values.cm_mmc;
	} else if(!values.cm_mmc && values.cm_sp) {
		return '?cm_sp='+values.cm_sp;
	} else if(!values.cm_mmc && !values.cm_sp) {
		return '';
	}
};

/* As the footnotes comes from AEM tool 
and they are not fully formated into an anchor
we need to replace the signs ## into a footnote mode */
export const compileDisclosureText = content => {
	
	return reactStringReplace(content, /##/, (match, idx) => {
		const { bankingType } = useContext(BankingTypeContext);
		const disclosureItem = match.split('DISCLOSURE-')[1];
		const labelTo = match.split('-').slice(1, 2).join('');
		const linkTo = match.split('-').slice(2, 3).join('');
		const baseName = process.env.REACT_APP_BASENAME === '/' ? '' : process.env.REACT_APP_BASENAME;
		if(disclosureItem !== undefined) {
			return sanitizeHtml(`<sup key=${idx} class="footnote"><a href=${'#footnote'+disclosureItem} class="js-foot" aria-label=${'Footnote '+disclosureItem}>${disclosureItem}</a></sup>`, { allowedTags: ['b', 'i', 'em', 'strong', 'a', 'sup'], allowedAttributes: { 'a': ['href', 'aria-label', 'target', 'id', 'class'], 'sup': ['class'] } });
		}
		if(linkTo !== undefined ){
			if(window.location.pathname.match('iframe')) {
				return sanitizeHtml(`<a href="${baseName+lobDemoSplit+`/iframe/${bankingType === SELECTORS.OLB ? SELECTORS.OLB : SELECTORS.MB}/`+linkTo}" target="_self" rel="noopener noreferrer">${labelTo}</a>`, { allowedTags: ['b', 'i', 'em', 'strong', 'a'], allowedAttributes: { 'a': ['href', 'aria-label', 'target', 'id', 'class', 'rel'] } });
			}else{
				return sanitizeHtml(`<a href="${baseName+lobDemoSplit+'/'+linkTo}" target="_self" rel="noopener noreferrer">${labelTo}</a>`, { allowedTags: ['b', 'i', 'em', 'strong', 'a'], allowedAttributes: { 'a': ['href', 'aria-label', 'target', 'id', 'class', 'rel'] } });
			}
		}
	});
}

// same as above but for the FDIC table
export const compileDisclosureFDIC = content => {
	if(content.match(`##FDIC##`)){
		return reactStringReplace(content, /##FDIC##/, () => {
			return sanitizeHtml(`<ul class="disclosures__fdic"><li>Are not FDIC insured</li><li>Are not Bank Guaranteed</li><li>May Lose Value</li></ul>`, { allowedTags: ['b', 'i', 'em', 'strong', 'a', 'sup', 'ul', 'li'], allowedAttributes: { 'a': ['href', 'aria-label', 'target', 'id'], 'sup': ['class'], 'ul': ['class', 'lang'] } });
		});
	}else{
		return reactStringReplace(content, /##SPANISH##/, () => {
			return sanitizeHtml(`<ul class="disclosures__fdic disclosures__fdic--spanish" lang="es-US"><li>Algunos materiales y contenidos en línea pueden estar disponibles solo en inglés.</li></ul>`, { allowedTags: ['b', 'i', 'em', 'strong', 'a', 'sup', 'ul', 'li'], allowedAttributes: { 'a': ['href', 'aria-label', 'target', 'id'], 'sup': ['class'], 'ul': ['class', 'lang'] } });
		});
	}
	
}

export const IsPending = () => <div className="show-loader"><img src={`${process.env.PUBLIC_URL}/assets/images/loader-large.gif`} alt="" /></div>;

export const Error = ({errorMessage}) => {
	console.error("Error Message:", errorMessage);
	if (window.location.pathname.includes('mobile') || window.location.pathname.includes('online') || window.location.pathname.includes('essentials') || window.location.pathname.includes('mpos')) {
		window.location = process.env.REACT_APP_BASENAME+'/404';
		return <div />;
	}else{
		window.history.replaceState('', '', '102');
		return (
			<Fragment>
				<ErrorGeneric errorCode={102}/>
			</Fragment>
		)
	}
}

/**
 * It removes the hashbang from the URL
 */
export const removeHashBang = () => {
	/* Checking if the URL has a hashbang. */
	if(window.location.hash !== ""){
		const bananaHash = window.location.hash;
        const directRoute = bananaHash.replace(/[#!]/g, '');
        window.history.replaceState("", "", sanitizeHtml(directRoute.substring(1)));
    }
}

/*
*
* query params function to get the cm_mmc and cm_sp values 
* from the query string in the URL
*
*/
export const QueryParams = () => {
	//Getting query parameter key and value from the page URL
	var getUrlParam = function(param) {
		var vars = {};
		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
		function(m, key, value) {
			if(!parts){
				vars[key] = value;
			}
		});
		if (typeof vars[param] !== 'undefined'){
			return vars[param];
		} else {
			return "";
		}
	};

	// Getting query parameter value from the URL and storing it to the variables
	var cm_mmc = getUrlParam('cm_mmc');
	var cm_sp= getUrlParam('cm_sp');
	var link = "";
	var qs = "";
	var newQs= "";

	//Updating all the links except the few with the query string

	var linkUpdate = function(elementId) {
		Array.prototype.forEach.call(elementId, function(linkElement){
			link = linkElement.getAttribute('href');
			if (cm_mmc !== "" && !link.match(`cm_mmc`) === true && link.match(`#footnote`) === null ) {
				qs = "cm_mmc=" + cm_mmc;
				newQs = (/\?/.test(link) ? '&' : '?') + qs;
				link += newQs;
				linkElement.setAttribute('href', link);
			}
			
			if (cm_sp !== "" && !link.match(`cm_sp`) === true && link.match(`#footnote`) === null ) {
				qs = "cm_sp=" + cm_sp;
				newQs = (/\?/.test(link) ? '&' : '?') + qs;
				link += newQs;
				linkElement.setAttribute('href', link);
			}
			
		});
		
	};
	let ctasLinks = document.querySelectorAll('a');
	linkUpdate(ctasLinks);
	
};